export default "__VITE_ASSET__CeTuZNst__"